<template>
    <el-tabs
        v-model="tabsActiveIndex"
        :stretch="true"
        class="window__aside-left"
    >
        <!-- 搜索 -->
        <div class="chat-search flex">
            <el-input
                v-model="searchValue"
                size="small"
                placeholder="请输入用户昵称搜索"
                :clearable="true"
                @change="handleSearch"
                @keyup.enter.native="handleSearch"
            />
            <div class="m-l-10">
                <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
            </div>
        </div>
        <div class="chat-user__list">
            <el-scrollbar class="ls-scrollbar scrollbar-wrapper">
                <loading-more v-model="pagination.status" @load="getUserList">
                    <chat-user-item
                        v-for="(item, index) in SessionList.user"
                        :key="item.key_id"
                        :is-read="item.is_read"
                        :name="item.chat_name"
                        :avatar="item.chat_img"
                        :message="item.content"
                        :active="current == item.key_user_id"
                        :time="item.send_time"
                        :online="item.online"
                        :msg-type="item.msg_type"
                        :id="item.key_user_id"
                        @click.native="changeCurrent(item, index)"
                    />
                </loading-more>
            </el-scrollbar>
        </div>
        <!-- 用户列表 -->
        <!-- <el-tab-pane
            class="chat-user__list"
            label="用户列表"
            :name="TabsMap['USER_LIST']"
        >
            <el-scrollbar class="ls-scrollbar scrollbar-wrapper">
                <loading-more v-model="pagination.status" @load="getUserList">
                    <chat-user-item
                        v-for="(item, index) in SessionList.user"
                        :key="item.key_id"
                        :is-read="item.is_read"
                        :name="item.chat_name"
                        :avatar="item.chat_img"
                        :message="item.content"
                        :active="current === item.send_id"
                        :time="item.send_time"
                        :online="item.online"
                        :msg-type="item.msg_type"
                        @click.native="changeCurrent(item, index)"
                    />
                </loading-more>
            </el-scrollbar>
        </el-tab-pane> -->

        <!-- 群聊列表 -->
        <!-- <el-tab-pane
            label=""
            :name="TabsMap['GROUP_CHAT']"
            disabled
        ></el-tab-pane> -->
    </el-tabs>
</template>


<script>
import ChatUserItem from '@/components/ChatUserItem'
import { apiChatUserList } from '@/api/app'
import LoadingMore from '@/components/LoadingMore'
import { E_Load } from '@/utils/enum'
import { mapGetters } from 'vuex'
export default {
    name: 'TheWindowAsideLeft',

    components: {
        ChatUserItem,
        LoadingMore,
    },

    props: {
        current: {
            type: [String, Number],
            require: true,
        },
        messageUserId: {
            type: [String, Number],
            require: true,
        },
    },
    inject: ['send'],
    data() {
        return {
            /* 搜素内容 */
            searchValue: '',
            /* Tabs 索引 */
            tabsActiveIndex: '',
            /* Tabs 映射 */
            TabsMap: Object.freeze({
                USER_LIST: '1',
                GROUP_CHAT: '2',
            }),
            /* 分页器 */
            pagination: {
                size: 10,
                page: 1,
                status: E_Load['EMPTY'],
            },

            /* 会话列表 */
            SessionList: {
                user: [],
                search: [],
            },

            /* 当前会话 */
            // sessionCurrent: '',
        }
    },
    watch: {
        messageUserId: {
            handler(newVal, oldVal) {
                if(newVal) {
                    console.log('messageUserId', newVal)
                    this.pagination.status = E_Load['NORMAL']
                    this.getUserList()
                }
            },
            immediate: true
        }
    },
    created() {
        /* 初始化Tabs选项 */
        this.tabsActiveIndex = this.TabsMap['USER_LIST']
        this.$on('useronline', this.useronlineEvent)
        this.$on('transfer', this.transferEvenr)
        this.$on('message', this.messageEvenr)

        // this.getUserList()
    },
    computed: {
        
    },
    methods: {
        /**
         * 获取用户列表
         */
        getUserList() {
            return new Promise((resolve, reject) => {
                const { size, page, status } = this.pagination
               
                if (status == E_Load['EMPTY']) return
                if (!this.messageUserId) {
                    this.pagination.status = E_Load['EMPTY']
                    this.$message.error('登录失败，获取客户列表失败')
                    return
                }
                apiChatUserList({
                    uid: this.messageUserId,
                    page
                })
                    .then((data) => {
                        if(!data) return
                        this.pagination.page++
                        const dataList = Object.keys(data).map(item => {
                            return {
                                ...data[item],
                                key_id: item,
                                key_user_id: item.split('id_')[1]
                            }
                        })
                        this.SessionList.user = dataList
                        this.SessionList.search = dataList
                        // 防止列表出现重复的用户
                        // data.lists.forEach((item) => {
                        //     let index = this.SessionList.user.findIndex(uitem => uitem.user_id ==  item.user_id)
                        //     if(index == -1) {
                        //         this.SessionList.user.push(item)
                        //     }
                        // })
                        this.pagination.status = E_Load['NORMAL']
                        this.$nextTick(() => {
                            if (!dataList.length < size) {
                                this.pagination.status = E_Load['EMPTY']
                            }
                        })
                        resolve(data)
                    })
                    .catch((err) => {

                        this.pagination.status = E_Load['NORMAL']
                        reject(err)
                    })
                    .finally(() => {})
            })
        },
        /**
         * 搜索用户列表
         */
        handleSearch() {
            // this.pagination.page = 1
            // this.pagination.status = E_Load['LOAD']
            // this.SessionList.user = []
            // this.getUserList()
            this.SessionList.user = this.SessionList.search.filter((item) => {
                return item.chat_name.includes(this.searchValue)
            })
            if (!this.searchValue) {
                this.SessionList.user = this.SessionList.search
            }
        },
        /**
         * 转接事件
         */
        transferEvenr(data) {
            if (data.status == 'get_success') {
                this.setUser(data.user)
                this.$notify.success({
                    title: '转接通知',
                    message: `您有新的用户`,
                })
                return
            }

            this.SessionList.user = this.SessionList.user.filter((item) => {
                return item.user_id != this.current
            })
            this.$emit('change', '')
            this.$message.success({
                message: `转接成功`,
            })
        },
        /**
         * 用户上下线事件
         */
        useronlineEvent(data) {
            if (data.online) {
                this.$notify.success({
                    title: '上线通知',
                    message: `用户（${data.nickname}）上线`,
                })
            }
            this.setUser(data)
        },
        /**
         * 消息事件
         */
        messageEvenr(data) {
            console.log(data, '用户列表收到信息')
            let index = this.SessionList.user.findIndex((item) => {
                const from_id = item.key_id.split('id_')[1] // 会话人id == 68862
                // console.log(from_id, data.from_id, 'from_id, data.from_id')
                if(data.from_id == from_id) { // 对方发送比自己
                    return item.key_id == ('id_' + data.from_id)
                } else if (data.send_id == from_id) { // 自己发送比对方
                    return item.key_id == ('id_' + data.send_id)
                }
            })
            
            if (index != -1) {
                // 更新用户列表聊天
                this.$set(this.SessionList.user[index], 'msg_type', data.msg_type)
                this.$set(this.SessionList.user[index], 'content', data.content)
                this.$set(
                    this.SessionList.user[index],
                    'send_time',
                    data.send_time
                )
                // 如果不是和当前用户聊天时接收到新消息，标记未读
                if (data.from_id != this.current) {
                    this.$set(this.SessionList.user[index], 'is_read', 0)
                }
                // 如果是当前用户发送的消息，标记已读
                if (data.from_id == this.messageUserId) {
                    this.$set(this.SessionList.user[index], 'is_read', 1)
                }
            } else {
                // 新增用户列表聊天
                if (data.send_id == this.messageUserId) {
                    const user = Object.assign(data, {
                        chat_img: data.from.img,
                        chat_name: data.from.name,
                        key_id: 'id_' + data.from_id,
                        key_user_id: data.from_id,
                    })
                    console.log(user, '新增用户列表聊天')
                    this.SessionList.user.push(user)
                }
            }
        

            if (data.from_type == 'user') {
                if (data.from_id == this.current) {
                    this.send('read', {
                        user_id: this.current
                    })
                    return
                }
                this.$set(this.SessionList.user[index], 'is_read', 0)
            }
        },
        /**
         * 选中用户改变
         */
        changeCurrent(item, index) {
            const send_id = item.key_id.split('id_')[1]
            this.$emit('change', send_id, this.SessionList.user[index])
            if (!item.is_read) {
                this.send('read', {
                    user_id: send_id
                })
                this.$set(this.SessionList.user[index], 'is_read', 1)
            }

            console.log(item, index, this.current)
        },
        // 改变用户上下线的状态
        setUser(data) {
            let index = this.SessionList.user.findIndex(
                (item) => data.user_id == item.user_id
            )
            if (index != -1) {
                this.$set(this.SessionList.user[index], 'online', data.online)
            } else {
                this.SessionList.user.unshift(data)
            }
        },
    },
}
</script>


<style lang="scss" scoped>
.window__aside-left {
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;

    .chat-search {
        padding: 0 10px 10px 10px;
    }

    &::v-deep .el-tabs__content {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    .chat-user__list {
        flex: 1;
        display: flex;
    }

    .scrollbar-wrapper {
        flex: 1;
        height: 100%;
    }
}
</style>
